import { breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

export const DateDottedLine = styled.div<{ $right: number }>`
  border-left: 1px dashed var(--border-primary);
  position: absolute;
  top: 0px;
  right: ${({ $right }) => $right}px;
  width: 1px;
  height: 200px;
  z-index: 1;

  @media ${breakpoints['max-lg']} {
    right: calc(${({ $right }) => $right}px * 0.7);
  }
`;
